import { DatePipe } from "@angular/common";
import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { EntityPagedResult, BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import moment from "moment";
import { ROLE_GESTOR_ENVIO, ROLE_AGENTE_CONSULTA } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { Cotista } from "src/app/model/cotista.model";
import { Subscricao } from "src/app/model/subscricao.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { ExportService } from "../../export.service";
import { SelectCotistaComponent } from "../../select-cotista/select-cotista.component";
import { SubscricaoService } from "../../subscricao.service";


@Component({
    selector: 'app-subscricao-cotas-pesquisa',
    templateUrl: './subscricao-cotas-pesquisa.component.html',
    standalone: false
})
export class SubscricaoCotasPesquisaComponent implements OnInit {

  atributosPaginacaoComponenteListagem: EntityPagedResult<Subscricao>;
  pesquisado: boolean = false;
  cnpjUsuario: string;
  pesquisaForm: UntypedFormGroup;
  opcoesPaginacao: number[];
  subscricoes: Subscricao[];
  podeCadastrarSubscricao: boolean;
  agentesFinanceiros: AgenteFinanceiro[] = [];
  categorias: string[];
  cotista: Cotista;
  msgSemResultado: boolean = false;
  dataHoraResultado: string;
  @ViewChild(SelectCotistaComponent) selectCotistaComponent: SelectCotistaComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private datePipe: DatePipe,
    private formBuilder: UntypedFormBuilder,
    private bnLoadingService: BnLoadingService,
    private subscricaoService: SubscricaoService,
    private permissaoService: PermissaoService,
    private exportService: ExportService,
    private bnUsuarioService: BnUsuarioService,
    private el: ElementRef,
  ) {
    this.pesquisaForm = this.formBuilder.group({
      id: null,
      categoriaCota: null,
      dataSubscricaoInicial: null,
      dataSubscricaoFinal: null,
      tipoCotista: null,
      cnpjUsuario: null,
    });
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false);
  }

  ngOnInit() {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.permissaoService.getPermissoesUsuarioAutenticado()
      .subscribe((resp: any) => {
        this.podeCadastrarSubscricao = resp && resp[ROLE_GESTOR_ENVIO];
        if (resp && resp[ROLE_AGENTE_CONSULTA]) {
          this.bnUsuarioService.usuario$.subscribe(usuario => {
            if (usuario && usuario.cnpj) {
              this.cnpjUsuario = usuario.cnpj;
              this.construirFormulario(usuario.cnpj)
            }
          });
        } else {
          this.construirFormulario();
        }
      });
    this.subscricaoService.getCategorias().subscribe(response => {
      this.categorias = response;
    });
  }

  private construirFormulario(cnpj?: string) {
    const valoresPesquisaForm = JSON?.parse(sessionStorage.getItem('valoresPesquisaSubscricoesCotasForm'));
    if (valoresPesquisaForm) {
      this.pesquisaForm.setValue({
        id: this.cotista?.id || null,
        categoriaCota: valoresPesquisaForm.categoriaCota,
        dataSubscricaoInicial: valoresPesquisaForm.dataSubscricaoInicial,
        dataSubscricaoFinal: valoresPesquisaForm.dataSubscricaoFinal,
        tipoCotista: valoresPesquisaForm.tipoCotista,
        cnpjUsuario: valoresPesquisaForm.cnpjUsuario,
      });
    }
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      sessionStorage.setItem('valoresPesquisaSubscricoesCotasForm', JSON.stringify(novosValores));
    });
  }

  limpar() {
    this.pesquisaForm.reset();
    this.atributosPaginacaoComponenteListagem.page = 1;
    this.pesquisado = false;
    if (!this.cnpjUsuario) {
      this.selectCotistaComponent.limparSelect();
      this.cotista = null;
    }
    setTimeout(() => {
      this.removeNgInvalidInput('dataSubscricaoInicial');
      this.removeNgInvalidInput('dataSubscricaoFinal');
    }, 100);
    this.subscricoes = [];
    this.msgSemResultado = false;
  }

  removeNgInvalidInput(id: string) {
    const inputElement = this.el.nativeElement.querySelector(`#${id}`);
    inputElement.classList.remove('ng-invalid');
  }

  mudancaPagina(novaPagina: EntityPagedResult<Subscricao>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(true);
  }

  buscar(paginado: boolean) {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    dadosPreenchidos.pagina = paginado ? this.atributosPaginacaoComponenteListagem.page : 1;
    dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    this.subscricaoService.getSubscricoes(dadosPreenchidos).
      subscribe((response => {
        this.pesquisado = true;
        this.subscricoes = response ? response.resultados : null;
        this.atributosPaginacaoComponenteListagem.count = response ?
          response.totalRegistrosSemPaginacao : 0;
        this.msgSemResultado = (this.atributosPaginacaoComponenteListagem.count === 0) || false;
        this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
      }));
    this.bnLoadingService.liberaTela();
  }

  tratarInformacoesPreenchidas() {
    let dadosPreenchidos: any = {};
    const form = this.pesquisaForm.value;
    if (form.dataSubscricaoInicial) {
      dadosPreenchidos.dataSubscricaoInicial = this.datePipe.transform(form.dataSubscricaoInicial, 'yyyyMMdd');
    }
    if (form.dataSubscricaoFinal) {
      dadosPreenchidos.dataSubscricaoFinal = this.datePipe.transform(form.dataSubscricaoFinal, 'yyyyMMdd');
    }
    if (form.categoriaCota) {
      dadosPreenchidos.categoriaCota = form.categoriaCota;
    }

    if (this.cnpjUsuario && this.cotista) {
      const cotista = this.cotista;
      dadosPreenchidos.tipoCotista = cotista.tipoCotista;
      dadosPreenchidos.cnpjUsuario = this.cnpjUsuario;
      dadosPreenchidos.idCotista = cotista.id;
    } else if (this.cotista) {
      const cotista = this.cotista;
      dadosPreenchidos.tipoCotista = cotista?.tipoCotista || null;
      dadosPreenchidos.idCotista = cotista?.id || null;
    }
    return dadosPreenchidos;
  }

  exportarSubscricoes() {
    this.bnLoadingService.bloqueiaTela();
    const dadosPreenchidos = this.tratarInformacoesPreenchidas();
    this.subscricaoService.getSubscricoes(dadosPreenchidos).subscribe((resp) => {
      this.exportService.exportarSubscricoes(resp);
    });
  }

  selecionaCotista(data) {
    this.cotista = data ? data : null;
  }

}
